module.exports = __webpack_public_path__ + "static/media/JCB.4db0123d.svg";